import { Prop, Watch } from 'vue-property-decorator'
import { DeskData } from '@/datamodel/deskdata'
import { Action, Getter } from 'vuex-class'
import RoadMapView from '@/components/roadmap/index.vue'
import { RoadMapData } from '@/components/roadmap/data-model'
import { DeskMoreInfoModel } from '@/datamodel/urlparams/DeskMoreInfoModel'
import { Options, Vue } from 'vue-class-component'
import { ResponseData } from '@/datamodel/response-data'
import { TableLimit } from '@/datamodel/types'
import { useI18n } from 'vue-i18n'
import { MemberLimit, Table } from 'vue'
import { store } from '@/store'
import { DeskMutation } from '@/store/module/desk'
import { Device } from '@/store/types'
import {
    formatGoodRoadName,
    getTableGoodRoads,
    isGoodRoadGameType
} from '@/components/desk/good-road/utils'

@Options({
    components: {
        RoadMapView
    }
})
export class SwitchTableItemMixin extends Vue {
    iN = useI18n().t
    roadMapData!: RoadMapData

    currentTime = -1
    deskTimer: number | boolean = false

    deskResult = ''
    $emit!: Vue['$emit']

    @Prop() mdata!: Table
    @Prop({ default: false }) isClicked!: boolean

    @Prop({ default: true }) showSelected!: boolean

    @Getter('userLimits') userLimits!: Array<MemberLimit>
    @Getter('device') device!: Device

    //#region Vuex Action
    @Action('getDeskOtherInfo') getDeskOtherInfo!: (
        model: DeskMoreInfoModel
    ) => Promise<ResponseData>
    @Action('destroySession') destroySession!: () => void
    @Action('setDeskLimit') setDeskLimit!: (limit: TableLimit) => void
    @Action('setDeskNotice') setDeskNotice!: (notice: string) => void
    @Action('setChipsValues') setChipsValues!: (
        chipvalues: Array<number>
    ) => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('showLoading') showLoading!: () => void

    // //#endregion

    beforeUnmount(): void {
        this.StopDeskTimer()
    }

    enterDesk(limit: TableLimit): void {
        store.commit(DeskMutation.SET_DESK_LIMIT, limit)
        this.$emit('enter-table', this.mdata)
    }

    StopDeskTimer(): void {
        if (typeof this.deskTimer === 'number') {
            clearInterval(this.deskTimer)
            this.deskTimer = false
            this.currentTime = -1
        }
    }

    get timerClass(): string {
        if (this.currentTime > 20) {
            return 'green'
        } else if (this.currentTime <= 20 && this.currentTime > 10) {
            return 'orange'
        } else {
            return 'red'
        }
    }

    get title(): string {
        if (this.mdata.gameTypeNo === 'G002') {
            return `百家乐 ${this.mdata.tableNo} 号桌`
        } else {
            return `龙虎 ${this.mdata.tableNo} 号桌`
        }
    }

    get goodRoadName(): string {
        if (!this.mdata || !isGoodRoadGameType(this.mdata.gameTypeNo)) {
            return ''
        }

        const goodRoads = getTableGoodRoads(this.mdata)
        if (!goodRoads.length) return ''

        return formatGoodRoadName(goodRoads[0].id, this.mdata.gameTypeNo)
    }

    get isSelected(): boolean {
        const params = new URLSearchParams(window.location.search)
        const _desk = parseInt(params.get('desk') || '0')

        if (_desk) {
            return _desk === this.mdata.id && this.showSelected
        }

        return false
    }
    get juNo() {
        return this.mdata.expand.juNo
    }

    get shoe() {
        return this.mdata.expand.shoeNo
    }

    @Watch('mdata', { immediate: true })
    OnDataChange(value: Table): void {
        if (value) {
            this.deskResult = value.expand.resultList.join('#') || ''

            if (
                value.expand.daoJiShiBetTime > 0 &&
                typeof this.deskTimer !== 'number'
            ) {
                this.currentTime = value.expand.daoJiShiBetTime
                this.deskTimer = setInterval(() => {
                    if (this.currentTime > 0) {
                        this.currentTime -= 1
                    } else {
                        this.StopDeskTimer()
                    }
                }, 1000)
            } else if (
                value.expand.daoJiShiBetTime === -1 &&
                typeof this.deskTimer === 'number'
            ) {
                this.StopDeskTimer()
            }
        }
    }
}
